module.exports = "https://static.energy5.com/_next/static/images/percent2k-4bfc726d30946ec8e48d6ab73bd097dc.png";